<template>
  <button
    type="button"
    class="text-primary border-primary border-1 relative overflow-hidden px-3 py-2 text-sm font-medium disabled:opacity-40"
    :class="brandButtonClass"
  >
    <slot />
    <template v-if="isLoading">
      <BaseInnerLoading />
    </template>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  isLoading?: boolean
}>()

const brandButtonClass =
  import.meta.env.VITE_ORGANIZATION === "boipa"
    ? "rounded-tl-3xl rounded-br-3xl"
    : "rounded-lg"
</script>
